
/*
    The API requests related to all message types:
    queued, location. TTS, stored text
*/

import axios from "axios";
import BaseValues from "./BaseValues";

//
// get the queued messaged which match the given filter
//
export const getGeneralMessages = (params) => {
    /*
        location: "",
        routes: [],
        route: "",
        lanes: [],
        lane: ""
    */

    console.log("GET GENERAL MESSAGES", params);

    const data = BaseValues.createFormData({
        terminal: params.location,
        startdate: params.startDate ? `${BaseValues.createDateString(params.startDate)}` : "",
        enddate: params.endDate ? `${BaseValues.createDateString(params.endDate)}` : "",
        route: params.route,
        lane: params.lane,
        enable: "",
        groupid: params.groupid ? (params.groupid+"").toUpperCase() : "",
        days: params.daysOfWeek
    });
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/getQueuedMessages`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// create a new queued message record
//
export const addGeneralMessage = (message) => {

    console.log("message", message);

    const data = BaseValues.createFormData({
        route: message.routesSelected.join(","),
        // we're just going to take the first location for now
        terminal: message.locationsSelected.join(","),
        lane: message.lanesSelected.join(","),
        startdate: BaseValues.createDateString(message.startDate) + " " + message.startTime,
        enddate: BaseValues.createDateString(message.endDate) + " " + message.endTime,
        enable: message.enabled ? "true" : "false",
        phrase: message.phrase,
        interval: message.minuteInterval,
        frequency: message.daysOfWeek,
        emissions: message.repetitionNumber,
        service_type: message.serviceType,
        direction: "", //message.inbound ? "I" : "O",
        groupid: message.groupid,
        playNow: !message.scheduled //"" //message.playNow ? "true" : "false"
    });

    const url = `${BaseValues.BaseURL}/api/BUSConsole/addNewQueuedMessage`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// edit an individual queued message
//
export const updateGeneralMessage = (message) => {

    console.log("message", message);

    const data = BaseValues.createFormData({
        messageID: message.messageId,
        route: message.routesSelected.join ? message.routesSelected.join(",") : "",
        // we're just going to take the first location for now
        terminal: message.locationsSelected.join ? message.locationsSelected.join(",") : "",
        lane: message.lanesSelected.join ? message.lanesSelected.join(",") : "",
        startdate: BaseValues.createDateString(message.startDate) + " " + message.startTime,
        enddate: BaseValues.createDateString(message.endDate) + " " + message.endTime,
        enable: message.enabled ? "true" : "false",
        phrase: message.phrase,
        interval: message.minuteInterval,
        frequency: message.daysOfWeek,
        emissions: message.repetitionNumber,
        service_type: message.serviceType,
        direction: "", //message.inbound ? "I" : "O",
        groupid: message.groupid
    });
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/updateQueuedMessage`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// switch the enabled status of a queued message
//
export const enableOrDisableMessage = (messageID, enable) => {

    const data = BaseValues.createFormData({
        messageID,
        enable: enable ? "true" : "false",
    });
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/updateQueuedMessage`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// delete a queued message
//
export const deleteGeneralMessage = (messageid) => {
    const data = BaseValues.createFormData({messageid});
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/deleteQueuedMessage`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get a list of reusable message text for use in creating a new queued message
//
export const getStoredMessages = () => {
    const data = BaseValues.createFormData({});
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/getStoredMessages`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// add a new message text to the reusable list
//
export const addStoredMessage = (phrase) => {
    const data = BaseValues.createFormData({phrase});
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/addStoredMessage`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// update one of the reusable message text records
//
export const updateStoredMessage = (oldphrase, newphrase) => {
    const data = BaseValues.createFormData({oldphrase, newphrase});
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/updateStoredMessage`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// delete one of the reusable message text records
//
export const deleteStoredMessage = (phrase) => {
    const data = BaseValues.createFormData({phrase});
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/deleteStoredMessage`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

/////////////////////////////////////////////////////////////////

//
// get the messages associated with each location
//
export const getLocationMessages = () => {
    const data = BaseValues.createFormData({});
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/getlocationmessages`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// update one of the location messages
//
export const updateLocationMessage = (params) => {
    const data = BaseValues.createFormData({
        locationid: params.location,
        message: params.message,
        fullscreen: params.fullscreen ? "true" : "false"
    });
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/updatelocationmessage`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
};

/////////////////////////////////////////////////////////////////

//
// get the list of all TTS messages
//
// NOT YET IMPLEMENTED
//
export const getTTSMessages = () => {
    const baseObject = {
        I_ALL: true,
        O_ALL: true,
        I_NM: true,
        I_NB: false,
        I_DEL: false,
        I_LGCH: true,
        I_CAN: true,
        I_RON: true,
        I_ROFF: true,
        I_ROFFTTS: false,
        O_NM: true,
        O_NB: false,
        O_DEL: false,
        O_LGCH: true,
        O_CAN: false,
        O_RON: false,
        O_ROFF: true,
        O_ROFFTTS: false
    };

    const locations = [
        {
            location: "ATLANTIC CITY",
            code: "ACBTDOWN"
        },
        {
            location: "ATLANTIC CITY",
            code: "ACBTUPTW"
        },
        {
            location: "BROADWAY TERMINAL",
            code: "BWAYTERM"
        },
        {
            location: "AVANDALE PARK/RIDE",
            code: "AVANDALE"
        },
        {
            location: "BUS STOP",
            code: "RAYMNJHQ"
        },
        {
            location: "GEORGE WASHINGTON BRIDGE",
            code: "NWYKGWBT"
        },
        {
            location: "HOBOKEN TERMINAL",
            code: "HUDSLAN6"
        },
        {
            location: "HOBOKEN TERMINAL",
            code: "HUDSTERM"
        },
        {
            location: "IRVINGTON TERMINAL",
            code: "IRV TERM"
        },
        {
            location: "LAKEWOOD TERMINAL",
            code: "LAKEWOOD"
        },
        {
            location: "MARKET STREET BUS LANES",
            code: "MKTSPENN"
        },
        {
            location: "MARKET STREET BUS LANES",
            code: "PENN MKTS"
        }
    ];

    const data = locations.map(loc => {
        return {...baseObject, ...loc};
    });

    const promise = new Promise((resolve, reject) => {
        resolve({data});
    });

    return promise.catch(BaseValues.handleError);
}

//
// update all TTS messages as a batch
//
// NOT YET IMPLEMENTED
//
export const updateTTSMessages = (messages) => {
    const data = {};

    const promise = new Promise((resolve, reject) => {
        resolve({data});
    });

    return promise.catch(BaseValues.handleError);
}